// Palette values for the TypeScript side of the app — the PrimeNG preset and rpo-chart, which
// can't reach into _style-vars.scss. Every entry mirrors a token in _style-vars.scss except
// mediumColor, which exists only as PrimeNG's `medium` primitive. When a value changes in
// _style-vars.scss, change it here too.
export const TOKENS = {
  // $primary-color now resolves to the accent, so these three are the navy surface step, not the
  // primary action color. PrimeNG reads PRIMARY_RAMP for that.
  primary: '#2b303a', // $navy-deep / $dark-color
  primaryDark: '#2b303a', // $navy-deep / $dark-color
  navyDeep: '#2b303a', // $navy-deep / $dark-color

  accentBlue: '#00a9be', // $accent-blue / $arpio-blue
  accentBlueMid: '#0098ab', // $accent-blue-mid / $accent-color-dark
  accentBlueStrong: '#00a9be', // $accent-blue-strong / $accent-text-on-light

  darkColor: '#2b303a', // $dark-color
  lightGray: '#6b7280', // $light-gray
  mediumColor: '#ebebeb', // used as the PrimeNG `medium` primitive
  lightColor: '#ffffff', // $light-color
  bannerBg: '#e8e8e8', // $banner-bg — app-overview banner surface

  orange: '#ff4000', // $arpio-orange / $danger-color
  warn: '#f1b122', // $warn-color
  success: '#03a039', // $success-color
} as const

// PrimeNG's `semantic.primary` needs a full 50-950 scale, which the brand doesn't define. The
// accent sits at 500 and the rest are tints and shades extended from it, so the ramp stays the
// brand's hue rather than a generic blue.
export const PRIMARY_RAMP = {
  50: '#f2fbfc',
  100: '#c2eaef',
  200: '#91dae3',
  300: '#61cad7',
  400: '#30b9ca',
  500: TOKENS.accentBlue,
  600: '#0090a2',
  700: '#007685',
  800: '#005d69',
  900: '#00444c',
  950: '#002a30',
} as const
